/**
 * Project: fuse-react-app
 * FilePath: /src/index.js
 * File: index.js
 * Created Date: Tuesday, November 27th 2018, 7:45:42 pm
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Wed Jan 23 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

import 'babel-polyfill'
import 'typeface-muli'

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import { create } from 'jss'
import jssExtend from 'jss-extend'
import JssProvider from 'react-jss/lib/JssProvider'
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles'

import registerServiceWorker from './client/registerServiceWorker'

import store from './client/store'

import App from 'client/app.jsx'

const jss = create({
  ...jssPreset(),
  plugins: [...jssPreset().plugins, jssExtend()]
})

jss.options.insertionPoint = document.getElementById('jss-insertion-point')
const generateClassName = createGenerateClassName()

ReactDOM.render(
  <JssProvider jss={jss} generateClassName={generateClassName}>
    <Provider store={store}>
      <App />
    </Provider>
  </JssProvider>,
  document.getElementById('root')
)

registerServiceWorker()
